/*
 * The status dot + uppercase eyebrow label above each card title. `dot` picks
 * the dot colour/pulse (ok = teal pulse ring, warn = amber, busy = magenta);
 * `tone` tints the label text (ok/warn/err), or leaves it muted when omitted
 * (the processing "Packaging" eyebrow).
 */
const StatusEyebrow = ({ dot, tone, text }) => (
  <div className="eyebrow-row">
    <span className={`status-dot ${dot}`} aria-hidden="true" />
    <span className={`eyebrow-txt${tone ? ` ${tone}` : ""}`}>{text}</span>
  </div>
);

export default StatusEyebrow;
